<template>
    <b-container class="py-5">
        <b-row>
            <b-col class="text-center">
                <h1 class="display-4 mb-3 ">Server Error</h1>
                <p class="mb-3">The server did not respond to the request. Please try again later.</p>
                <b-button to="/" variant="primary">Back to homepage</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
